export enum SessionStorageKeys {
  TRAININGREQUIREMENTS_FILTER_FORM = 'TRAINING_REQUIREMENT_FILTER_FORM',
  REDIRECT_URL = 'redirectUrl',
  EXT_GRANT_URL = 'extgrantfullurl'
}
